__turbopack_context__.v({
  "className": "work_sans_a54f77ee-module__7ZqcoW__className",
  "variable": "work_sans_a54f77ee-module__7ZqcoW__variable",
});
